import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Tooltip, Typography } from '@mui/material'

import { ReactComponent as InfoCircle } from '../../../assets/icons/info-circle.svg'

import useStyles from './styles'

const TooltipButton = ({ title, placement = 'bottom', type, ...props }) => {
  const classes = useStyles()

  return (
    <Tooltip
      placement={placement}
      title={<Typography variant="body2">{title}</Typography>}
      classes={{ tooltip: type }}
      {...props}
    >
      <InfoCircle className={clsx(classes.icon, type)} />
    </Tooltip>
  )
}

TooltipButton.propTypes = {
  title: PropTypes.string.isRequired,
  placement: PropTypes.oneOf(['bottom', 'left', 'right', 'top']),
  type: PropTypes.oneOf(['', 'info', 'primary']),
}

export default TooltipButton
